import { render, staticRenderFns } from "./AdminProducts.vue?vue&type=template&id=fcf8523c&scoped=true"
import script from "./AdminProducts.vue?vue&type=script&lang=js"
export * from "./AdminProducts.vue?vue&type=script&lang=js"
import style0 from "./AdminProducts.vue?vue&type=style&index=0&id=fcf8523c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf8523c",
  null
  
)

export default component.exports